var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VideoChat"},[(_vm.isLive)?_c('JitsiVideo',{attrs:{"roomName":_vm.room,"displayName":_vm.name,"avatar":_vm.imageUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }